import React, { FC } from 'react'
import { StyledContent } from './styles'
import { Content } from '../../../components/content/Content'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

const ImprintPage: FC = () => {
	return (
		<PublicLayout>
			<StyledContent>
				<Content slug={'impressum'} />
			</StyledContent>
		</PublicLayout>
	)
}

export default ImprintPage
